'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.iconEditorWidget = function (iconEditorController, resouceDecompressor) {
	return mmWidgets.each(this, function () {
		const element = this,
			downloadFile = element.find('[data-mm-role~=download]'),
			heightField = element.find('[data-mm-role~=icon-height]'),
			positionField = element.find('[data-mm-role~=icon-position]'),
			widthField = element.find('[data-mm-role~=icon-width]'),
			image = element.find('[data-mm-role~=icon-img]'),
			uploadingImage = element.find('[data-mm-role~=icon-upload-img]'),
			ratioBox = element.find('[data-mm-role~=dimensions-ratio]'),
			submitButton = element.find('[data-mm-role~="submit"]'),
			reload = function () {
				const icon = iconEditorController.getCurrentIcon() || {};
				let src = icon.url;
				if (resouceDecompressor) {
					src = resouceDecompressor(icon.url);
				}
				image.attr('src', src);
				downloadFile.attr('href', icon.url);
				heightField.val(icon.height);
				widthField.val(icon.width);
				positionField.val(icon.position);
			};
		element.on('show', reload);
		iconEditorController.addEventListener('reload', reload);
		iconEditorController.addEventListener('stage', function (stage, url) {
			if (stage === 'confirm') {
				reload();
			} else if (stage === 'uploading') {
				uploadingImage.attr('src', url);
			}
		});
		submitButton.on('click', function () {
			const invalidInput = element.find('input.validation-error');
			if (invalidInput.length) {
				invalidInput.first().focus();
			} else {
				iconEditorController.setDimensions(
					widthField.val(),
					heightField.val()
				);
				iconEditorController.setPosition(positionField.val());
				iconEditorController.save();
			}
		});
		widthField.on('change', function () {
			const width = parseFloat(widthField.val());
			if (isNaN(width) || isNaN(widthField.val())) {
				return false;
			}
			if (ratioBox.domElements[0].checked) {
				const imageRect = image.domElements[0].getBoundingClientRect();
				heightField.val(Math.round(imageRect.height * width / imageRect.width));
			}
			submitButton.removeClass('hidden');
		});
		heightField.on('change', function () {
			const height = parseFloat(heightField.val());
			if (isNaN(heightField.val()) || isNaN(height)) {
				return false;
			}
			if (ratioBox.domElements[0].checked) {
				const imageRect = image.domElements[0].getBoundingClientRect();
				widthField.val(Math.round(imageRect.width * height / imageRect.height));
			}
			submitButton.removeClass('hidden');
		});
		positionField.on('change', function () {
			submitButton.removeClass('hidden');
		});
	});
};
